// extracted by mini-css-extract-plugin
module.exports = {"noBackdrop":"loader_noBackdrop__L8SF3","backdrop":"loader_backdrop__UPCA7","backdropFullWindow":"loader_backdropFullWindow__rlXQw"};